import Floating from './Floating';

export type { Placement, Middleware } from '@floating-ui/react';
export type { IProps as IFloatingProps } from './Floating';
export type {
  IFloatingControls,
  IFloatingElementProps,
  IFloatingRef,
  IReferenceElementProps,
} from './interfaces';
export default Floating;
